import { render, staticRenderFns } from "./MakeTag.vue?vue&type=template&id=15226cfc&scoped=true&"
import script from "./MakeTag.vue?vue&type=script&lang=js&"
export * from "./MakeTag.vue?vue&type=script&lang=js&"
import style0 from "./MakeTag.vue?vue&type=style&index=0&id=15226cfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15226cfc",
  null
  
)

export default component.exports